export default function VenturaLogo({ className = "h-[4.5rem] w-auto" }) {
  return (
    <img
      src={`${process.env.PUBLIC_URL || ""}/ventura-hr-logo.png`}
      alt="Ventura HR"
      className={`object-contain object-left ${className}`}
      draggable={false}
    />
  );
}
